import { useQuery, useLazyQuery } from "@apollo/react-hooks";
import React, { useState, useEffect, Fragment } from "react";
import moment from "moment";
import { DatePicker, Button, Table, Select, Tooltip, Tabs, Space, Typography } from "antd";
import { GET_DASHBOARD_4_CONTRACTOR, GET_DASHBOARD_4_DISCIPLINE, GET_DASHBOARD_4_LEVEL, GET_DASHBOARD_4_CHILD_PERMIT } from "../graphql/modules/dashboardv2_4";
import { warnNotify } from "../util";

const { Text } = Typography;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

export const DashboardV2D4 = () => {
    const [startDateByContractor, setStartDateByContractor] = useState('');
    const [endDateByContractor, setEndDateByContractor] = useState('');
    const [sitesByContractor, setSitesByContractor] = useState([]);
    const [permitStatusByContractor, setPermitStatusByContractor] = useState([]);

    const [startDateByDiscipline, setStartDateByDiscipline] = useState('');
    const [endDateByDiscipline, setEndDateByDiscipline] = useState('');
    const [sitesByDiscipline, setSitesByDiscipline] = useState([]);
    const [permitStatusByDiscipline, setPermitStatusByDiscipline] = useState([]);

    const [startDateByLevel, setStartDateByLevel] = useState('');
    const [endDateByLevel, setEndDateByLevel] = useState('');
    const [sitesByLevel, setSitesByLevel] = useState([]);
    const [permitStatusByLevel, setPermitStatusByLevel] = useState([]);

    const [startDateByChildPermit, setStartDateByChildPermit] = useState('');
    const [endDateByChildPermit, setEndDateByChildPermit] = useState('');
    const [sitesByChildPermit, setSitesByChildPermit] = useState([]);
    const [childPermitTypeByChildPermit, setChildPermitTypeByChildPermit] = useState('A');

    const [GetDashboard4ByContractor, { data: dataByContractor, loading: loadingByContractor}] = useLazyQuery(GET_DASHBOARD_4_CONTRACTOR, {
        variables: {
            startDate: startDateByContractor,
            endDate: endDateByContractor,
            sites: sitesByContractor,
            permitStatus: permitStatusByContractor,
        },
        fetchPolicy:  "cache-and-network",
    });
    const [GetDashboard4ByDiscipline, { data: dataByDiscipline, loading: loadingByDiscipline}] = useLazyQuery(GET_DASHBOARD_4_DISCIPLINE, {
        variables: {
            startDate: startDateByDiscipline,
            endDate: endDateByDiscipline,
            sites: sitesByDiscipline,
            permitStatus: permitStatusByDiscipline,
        },
        fetchPolicy:  "cache-and-network",
    });
    const [GetDashboard4ByLevel, { data: dataByLevel, loading: loadingByLevel}] = useLazyQuery(GET_DASHBOARD_4_LEVEL, {
        variables: {
            startDate: startDateByLevel,
            endDate: endDateByLevel,
            sites: sitesByLevel,
            permitStatus: permitStatusByLevel,
        },
        fetchPolicy:  "cache-and-network",
    });
    const [GetDashboard4ByChildPermit, { data: dataByChildPermit, loading: loadingByChildPermit}] = useLazyQuery(GET_DASHBOARD_4_CHILD_PERMIT, {
        variables: {
            startDate: startDateByChildPermit,
            endDate: endDateByChildPermit,
            sites: sitesByChildPermit,
            childPermitType: childPermitTypeByChildPermit,
        },
        fetchPolicy:  "cache-and-network",
    });

    const tableColumnsByContractor = [
    {
        title: 'Contractor Company',
        dataIndex: 'contractorCompany',
        key: 'contractorCompany',
        render: (text) => {
        return text ? <a>{text}</a> : <a>---</a>
        },
    },
    {
        title: 'General',
        dataIndex: 'generalPermitCount',
        key: 'generalPermitCount',
    },
    {
        title: 'Tool Install',
        dataIndex: 'toolPermitCount',
        key: 'toolPermitCount',
    },
    {
        title: 'Child Permit',
        dataIndex: 'childPermitCount',
        key: 'childPermitCount',
        },
    ]
    const disciplineColumns = [
    {
        title: 'Discipline',
        dataIndex: 'discipline',
        key: 'discipline',
        render: (text) => {
        return text ? <a>{text}</a> : <a>---</a>
        },
    },
    {
        title: 'General',
        dataIndex: 'generalPermitCount',
        key: 'generalPermitCount',
    },
    {
        title: 'Tool Install',
        dataIndex: 'toolPermitCount',
        key: 'toolPermitCount',
    },
    {
        title: 'Child Permit',
        dataIndex: 'childPermitCount',
        key: 'childPermitCount',
        },
    ]

    const levelColumns = [
    {
        title: 'Level',
        dataIndex: 'level',
        key: 'level',
        render: (text) => {
        return text ? <a>{text}</a> : <a>---</a>
        },
    },
    {
        title: 'General',
        dataIndex: 'generalPermitCount',
        key: 'generalPermitCount',
    },
    {
        title: 'Tool Install',
        dataIndex: 'toolPermitCount',
        key: 'toolPermitCount',
    },
    {
        title: 'Child Permit',
        dataIndex: 'childPermitCount',
        key: 'childPermitCount',
        },
    ]

    const childPermitColumns = [
    {
        title: 'Child Permit Type',
        dataIndex: 'childPermitType',
        key: 'childPermitType',
        render: (text) => {
            return text ? <p>{text}</p> : <p>---</p>
        },
    },
    {
        title: 'Pending PM Approval',
        dataIndex: 'pendingPMApprovalCount',
        key: 'pendingPMApprovalCount',
    },
    {
        title: 'Pending Individual Reviewer Approval',
        dataIndex: 'pendingIndividualReviewerCount',
        key: 'pendingIndividualReviewerCount',
    },
    {
        title: 'Pending MTGroup Approval',
        dataIndex: 'pendingMTGroupApprovalCount',
        key: 'pendingMTGroupApprovalCount',
    },
    {
        title: 'Approved',
        dataIndex: 'approvedCount',
        key: 'approvedCount',
    },
    ]

    const onChangeTab = (key) => {
        console.log(key);
    };

    /** By Contractor Functions */
    const handleContractorDateFrom = (dates, dateString) => {
        if (dates) {
            const formattedDates = dates.map(date => date.format('YYYY-MM-DD'));
            console.log(formattedDates);
            setStartDateByContractor(formattedDates[0]);
            setEndDateByContractor(formattedDates[1]);
        } else {
            console.log('No dates selected');
        }
    }

    const handleContractorSiteChange = (value) => {
        setSitesByContractor(value);
    };

    const handleContractorPermitStatusChange = (value) => {
        setPermitStatusByContractor(value);
    }

    const handleContractorSubmit = () => {
        console.log('Start Date: ', startDateByContractor);
        console.log('End Date: ', endDateByContractor);
        console.log('Sites: ', sitesByContractor);
        console.log('Permit Status: ', permitStatusByContractor);

        if(startDateByContractor !== '' && endDateByContractor !== '' || permitStatusByContractor !== '' || sitesByContractor.length > 0) {
            GetDashboard4ByContractor();
        }

        if(startDateByContractor === '' || endDateByContractor === '') {
            warnNotify('Please select date range');
        }

        if (permitStatusByContractor === '') {
            warnNotify('Please select permit type');
        }
        
        if (sitesByContractor.length <= 0) {
            warnNotify('Please select atleast one site');
        }
    }

    /** By Discipline Functions */
    const handleDisciplineDateFrom = (dates, dateString) => {
        if (dates) {
            const formattedDates = dates.map(date => date.format('YYYY-MM-DD'));
            console.log(formattedDates);
            setStartDateByDiscipline(formattedDates[0]);
            setEndDateByDiscipline(formattedDates[1]);
        } else {
            console.log('No dates selected');
        }
    }

    const handleDisciplineSiteChange = (value) => {
        setSitesByDiscipline(value);
    }

    const handleDisciplinePermitStatusChange = (value) => {
        setPermitStatusByDiscipline(value);
    }

    const handleDisciplineSubmit = () => {
        console.log('Start Date: ', startDateByDiscipline);
        console.log('End Date: ', endDateByDiscipline);
        console.log('Sites: ', sitesByDiscipline);
        console.log('Permit Status: ', permitStatusByDiscipline);

        if(startDateByDiscipline !== '' && endDateByDiscipline !== '' || permitStatusByDiscipline !== '' || sitesByDiscipline.length > 0) {
            GetDashboard4ByDiscipline();
        }

        if(startDateByDiscipline === '' || endDateByDiscipline === '') {
            warnNotify('Please select date range');
        }

        if (permitStatusByDiscipline === '') {
            warnNotify('Please select permit type');
        }
        
        if (sitesByDiscipline.length <= 0) {
            warnNotify('Please select atleast one site');
        }
    }

    /** By Level Functions */
    const handleLevelDateFrom = (dates, dateString) => {
        if (dates) {
            const formattedDates = dates.map(date => date.format('YYYY-MM-DD'));
            console.log(formattedDates);
            setStartDateByLevel(formattedDates[0]);
            setEndDateByLevel(formattedDates[1]);
        } else {
            console.log('No dates selected');
        }
    }

    const handleLevelSiteChange = (value) => {
        setSitesByLevel(value);
    }

    const handleLevelPermitStatusChange = (value) => {
        setPermitStatusByLevel(value);
    }

    const handleLevelSubmit = () => {
        console.log('Start Date: ', startDateByLevel);
        console.log('End Date: ', endDateByLevel);
        console.log('Sites: ', sitesByLevel);
        console.log('Permit Status: ', permitStatusByLevel);

        if(startDateByLevel !== '' && endDateByLevel !== '' || permitStatusByLevel !== '' || sitesByLevel.length > 0) {
            GetDashboard4ByLevel();
        }

        if(startDateByLevel === '' || endDateByLevel === '') {
            warnNotify('Please select date range');
        }

        if (permitStatusByLevel === '') {
            warnNotify('Please select permit type');
        }

        if (sitesByLevel.length <= 0) {
            warnNotify('Please select atleast one site');
        }
    }

    /** By Child Permits Functions */
    const handleChildPermitDateFrom = (dates, dateString) => {
        if (dates) {
            const formattedDates = dates.map(date => date.format('YYYY-MM-DD'));
            console.log(formattedDates);
            setStartDateByChildPermit(formattedDates[0]);
            setEndDateByChildPermit(formattedDates[1]);
        } else {
            console.log('No dates selected');
        }
    }

    const handleChildPermitSiteChange = (value) => {
        setSitesByChildPermit(value);
    }

    const handleChildPermitTypeChange = (value) => {
        setChildPermitTypeByChildPermit(value);
    }

    const handleChildPermitSubmit = () => {
        console.log('Start Date: ', startDateByChildPermit);
        console.log('End Date: ', endDateByChildPermit);
        console.log('Sites: ', sitesByChildPermit);
        console.log('Child Permit Type: ', childPermitTypeByChildPermit);

        if(startDateByChildPermit !== '' && endDateByChildPermit !== '' || childPermitTypeByChildPermit !== '' || sitesByChildPermit.length > 0) {
            GetDashboard4ByChildPermit();
        }

        if(startDateByChildPermit === '' || endDateByChildPermit === '') {
            warnNotify('Please select date range');
        }

        if (childPermitTypeByChildPermit === '') {
            warnNotify('Please select permit type');
        }

        if (sitesByChildPermit.length <= 0) {
            warnNotify('Please select atleast one site');
        }
    }

    useEffect(() => {
        // console.log('Data by Contractor');
        // console.table(dataByContractor);
        // console.log('Data by Discipline');
        // console.table(dataByDiscipline);
        // console.log('Data by Level');
        // console.table(dataByLevel);
        // console.log('Data by Child Permit');
        // console.table(dataByChildPermit);

    }, [dataByContractor, dataByDiscipline, dataByLevel, dataByChildPermit]);

    return (
        <Fragment>

            <div className="row dec-row">
                <div className="card">
                <div className="col-12 col-md-12">
                    <div className="col-12 col-md-12 text-left">
                        <h4 className="text-left">Permit Count by Date range and Site</h4>
                    </div>

                    <div className="row dec-row">
                        <div className="col-12 col-md-12">

                            <div className="col-12 col-md-12">
                                  <div className="card">
                                      <Tabs defaultActiveKey="1" onChange={onChangeTab} >

                                          <TabPane tab="by Contractor" key="1">
                                            <div className="row dec-row">
                                              <div className="col-12 col-md-12">
                                                <div className="col-3 col-md-3">
                                                        <Space
                                                            className="col-12 col-md-12"
                                                            direction="vertical"
                                                            size="middle"
                                                        >

                                                            <div className="col-12 col-md-12">
                                                                <RangePicker 
                                                                    style={{ width: "100%" }}
                                                                    id={{
                                                                        start: 'startInput',
                                                                        end: 'endInput',
                                                                      }}
                                                                    onChange={handleContractorDateFrom}
                                                                />
                                                            </div>

                                                            <div className="col-12 col-md-12">
                                                                <Select
                                                                        mode="multiple"
                                                                        allowClear
                                                                        placeholder="Please select site(s)"
                                                                        style={{
                                                                            width: '100%',
                                                                        }}
                                                                        onChange={handleContractorSiteChange}
                                                                        maxTagCount="responsive"
                                                                        maxTagPlaceholder={(omittedValues) => (
                                                                            <Tooltip
                                                                            styles={{
                                                                                root: {
                                                                                pointerEvents: 'none',
                                                                                },
                                                                            }}
                                                                            title={omittedValues.map(({ label }) => label).join(', ')}
                                                                            >
                                                                            <span>...</span>
                                                                            </Tooltip>
                                                                        )}
                                                                        options={
                                                                            [
                                                                                {
                                                                                    value: "604a288405a8ed2d4d4bba4b",
                                                                                    label: "Fab 10A1",
                                                                                },
                                                                                {
                                                                                    value: "604a286b05a8ed2d4d4bba4a",
                                                                                    label: "Fab 10A2",
                                                                                },
                                                                                {
                                                                                    value: "604a28bb05a8ed2d4d4bba4c",
                                                                                    label: "Fab 10N",
                                                                                },
                                                                                {
                                                                                    value: "60cafd5a4e8783df2ab8afff",
                                                                                    label: "Fab 10NX",
                                                                                },
                                                                                {
                                                                                    value: "6052a5b7be761a25aaec1bd1",
                                                                                    label: "Fab 10W",
                                                                                },
                                                                                {
                                                                                    value: "604a28ee05a8ed2d4d4bba4e",
                                                                                    label: "Fab 10X",
                                                                                }
                                                                            ]
                                                                        }
                                                                    />
                                                            </div>

                                                            <div className="col-12 col-md-12">
                                                                <Select
                                                                        allowClear
                                                                        placeholder="Permit Status"
                                                                        style={{
                                                                            width: '100%',
                                                                        }}
                                                                        onChange={handleContractorPermitStatusChange}
                                                                        maxTagCount="responsive"
                                                                        maxTagPlaceholder={(omittedValues) => (
                                                                            <Tooltip
                                                                            styles={{
                                                                                root: {
                                                                                pointerEvents: 'none',
                                                                                },
                                                                            }}
                                                                            title={omittedValues.map(({ label }) => label).join(', ')}
                                                                            >
                                                                            <span>...</span>
                                                                            </Tooltip>
                                                                        )}
                                                                        options={
                                                                            [
                                                                                {
                                                                                    value: "Pending PM Approval",
                                                                                    label: "Pending PM Approval",
                                                                                },
                                                                                {
                                                                                    value: "Pending Individual Reviewer Approval",
                                                                                    label: "Pending Individual Reviewer Approval",
                                                                                },
                                                                                {
                                                                                    value: "Pending MTGroup Approval",
                                                                                    label: "Pending MTGroup Approval",
                                                                                },
                                                                                {
                                                                                    value: "Approved",
                                                                                    label: "Approved",
                                                                                },
                                                                                {
                                                                                    value: "Pending Closure",
                                                                                    label: "Pending Closure",
                                                                                },
                                                                                {
                                                                                    value: "Completed",
                                                                                    label: "Completed",
                                                                                },
                                                                                {
                                                                                    value: "Cancelled",
                                                                                    label: "Cancelled",
                                                                                },
                                                                                {
                                                                                    value: "Rejected",
                                                                                    label: "Rejected",
                                                                                },
                                                                            ]
                                                                        }
                                                                    />
                                                            </div>

                                                            <div className="col-12 col-md-12">
                                                                <Button
                                                                    style={{
                                                                        width: '100%',
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleContractorSubmit();
                                                                    }}
                                                                >
                                                                    Submit
                                                                </Button>
                                                            </div>

                                                        </Space>
                                                </div>

                                                <div className="col-9 col-md-9">
                                                    <div className="card">
                                                        <Table 
                                                            pagination={true}
                                                            columns={tableColumnsByContractor}
                                                            loading={loadingByContractor}
                                                            dataSource={dataByContractor ? dataByContractor?.GetDashboard4ByDateRangeSitePermitStatusAndContractor.results : []}
                                                        />
                                                    </div>
                                                </div>
                                              </div>
                                            </div>
                                          </TabPane>

                                          <TabPane tab="by Discipline" key="2">
                                            <div className="row dec-row">
                                              <div className="col-12 col-md-12">
                                                <div className="col-3 col-md-3">
                                                    <Space
                                                        className="col-12 col-md-12"
                                                        direction="vertical"
                                                        size="middle"
                                                    >

                                                        <div className="col-12 col-md-12">
                                                            <RangePicker 
                                                                style={{ width: "100%" }}
                                                                onChange={handleDisciplineDateFrom}
                                                            />
                                                        </div>

                                                        <div className="col-12 col-md-12">
                                                            <Select
                                                                    mode="multiple"
                                                                    allowClear
                                                                    placeholder="Please select site(s)"
                                                                    style={{
                                                                        width: '100%',
                                                                    }}
                                                                    onChange={handleDisciplineSiteChange}
                                                                    maxTagCount="responsive"
                                                                    maxTagPlaceholder={(omittedValues) => (
                                                                        <Tooltip
                                                                        styles={{
                                                                            root: {
                                                                            pointerEvents: 'none',
                                                                            },
                                                                        }}
                                                                        title={omittedValues.map(({ label }) => label).join(', ')}
                                                                        >
                                                                        <span>...</span>
                                                                        </Tooltip>
                                                                    )}
                                                                    options={
                                                                        [
                                                                            {
                                                                                value: "604a288405a8ed2d4d4bba4b",
                                                                                label: "Fab 10A1",
                                                                            },
                                                                            {
                                                                                value: "604a286b05a8ed2d4d4bba4a",
                                                                                label: "Fab 10A2",
                                                                            },
                                                                            {
                                                                                value: "604a28bb05a8ed2d4d4bba4c",
                                                                                label: "Fab 10N",
                                                                            },
                                                                            {
                                                                                value: "60cafd5a4e8783df2ab8afff",
                                                                                label: "Fab 10NX",
                                                                            },
                                                                            {
                                                                                value: "6052a5b7be761a25aaec1bd1",
                                                                                label: "Fab 10W",
                                                                            },
                                                                            {
                                                                                value: "604a28ee05a8ed2d4d4bba4e",
                                                                                label: "Fab 10X",
                                                                            }
                                                                        ]
                                                                    }
                                                                />
                                                        </div>

                                                        <div className="col-12 col-md-12">
                                                            <Select
                                                                    allowClear
                                                                    placeholder="Permit Status"
                                                                    style={{
                                                                        width: '100%',
                                                                    }}
                                                                    onChange={handleDisciplinePermitStatusChange}
                                                                    maxTagCount="responsive"
                                                                    maxTagPlaceholder={(omittedValues) => (
                                                                        <Tooltip
                                                                        styles={{
                                                                            root: {
                                                                            pointerEvents: 'none',
                                                                            },
                                                                        }}
                                                                        title={omittedValues.map(({ label }) => label).join(', ')}
                                                                        >
                                                                        <span>...</span>
                                                                        </Tooltip>
                                                                    )}
                                                                    options={
                                                                        [
                                                                            {
                                                                                value: "Pending PM Approval",
                                                                                label: "Pending PM Approval",
                                                                            },
                                                                            {
                                                                                value: "Pending Individual Reviewer Approval",
                                                                                label: "Pending Individual Reviewer Approval",
                                                                            },
                                                                            {
                                                                                value: "Pending MTGroup Approval",
                                                                                label: "Pending MTGroup Approval",
                                                                            },
                                                                            {
                                                                                value: "Approved",
                                                                                label: "Approved",
                                                                            },
                                                                            {
                                                                                value: "Pending Closure",
                                                                                label: "Pending Closure",
                                                                            },
                                                                            {
                                                                                value: "Completed",
                                                                                label: "Completed",
                                                                            },
                                                                            {
                                                                                value: "Cancelled",
                                                                                label: "Cancelled",
                                                                            },
                                                                            {
                                                                                value: "Rejected",
                                                                                label: "Rejected",
                                                                            },
                                                                        ]
                                                                    }
                                                                />
                                                        </div>

                                                        <div className="col-12 col-md-12">
                                                            <Button
                                                                style={{
                                                                    width: '100%',
                                                                }}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleDisciplineSubmit();
                                                                }}
                                                            >
                                                                Submit
                                                            </Button>
                                                        </div>

                                                    </Space>
                                                </div>

                                                <div className="col-9 col-md-9">
                                                    <div className="card">
                                                        <Table 
                                                            pagination={true}
                                                            columns={disciplineColumns} 
                                                            loading={loadingByDiscipline}
                                                            dataSource={dataByDiscipline ? dataByDiscipline?.GetDashboard4ByDateRangeSitePermitStatusAndDiscipline.results : []}
                                                        />
                                                    </div>
                                                </div>
                                              </div>
                                            </div>
                                          </TabPane>

                                          <TabPane tab="by Level" key="3">
                                            <div className="row dec-row">
                                                <div className="col-12 col-md-12">
                                                    <div className="col-3 col-md-3">
                                                        <Space
                                                            className="col-12 col-md-12"
                                                            direction="vertical"
                                                            size="middle"
                                                        >

                                                            <div className="col-12 col-md-12">
                                                                <RangePicker 
                                                                    style={{ width: "100%" }}
                                                                    onChange={handleLevelDateFrom}
                                                                />
                                                            </div>

                                                            <div className="col-12 col-md-12">
                                                                <Select
                                                                        mode="multiple"
                                                                        allowClear
                                                                        placeholder="Please select site(s)"
                                                                        style={{
                                                                            width: '100%',
                                                                        }}
                                                                        onChange={handleLevelSiteChange}
                                                                        maxTagCount="responsive"
                                                                        maxTagPlaceholder={(omittedValues) => (
                                                                            <Tooltip
                                                                            styles={{
                                                                                root: {
                                                                                pointerEvents: 'none',
                                                                                },
                                                                            }}
                                                                            title={omittedValues.map(({ label }) => label).join(', ')}
                                                                            >
                                                                            <span>...</span>
                                                                            </Tooltip>
                                                                        )}
                                                                        options={
                                                                            [
                                                                                {
                                                                                    value: "604a288405a8ed2d4d4bba4b",
                                                                                    label: "Fab 10A1",
                                                                                },
                                                                                {
                                                                                    value: "604a286b05a8ed2d4d4bba4a",
                                                                                    label: "Fab 10A2",
                                                                                },
                                                                                {
                                                                                    value: "604a28bb05a8ed2d4d4bba4c",
                                                                                    label: "Fab 10N",
                                                                                },
                                                                                {
                                                                                    value: "60cafd5a4e8783df2ab8afff",
                                                                                    label: "Fab 10NX",
                                                                                },
                                                                                {
                                                                                    value: "6052a5b7be761a25aaec1bd1",
                                                                                    label: "Fab 10W",
                                                                                },
                                                                                {
                                                                                    value: "604a28ee05a8ed2d4d4bba4e",
                                                                                    label: "Fab 10X",
                                                                                }
                                                                            ]
                                                                        }
                                                                    />
                                                            </div>

                                                            <div className="col-12 col-md-12">
                                                                <Select
                                                                        allowClear
                                                                        placeholder="Permit Status"
                                                                        style={{
                                                                            width: '100%',
                                                                        }}
                                                                        onChange={handleLevelPermitStatusChange}
                                                                        maxTagCount="responsive"
                                                                        maxTagPlaceholder={(omittedValues) => (
                                                                            <Tooltip
                                                                            styles={{
                                                                                root: {
                                                                                pointerEvents: 'none',
                                                                                },
                                                                            }}
                                                                            title={omittedValues.map(({ label }) => label).join(', ')}
                                                                            >
                                                                            <span>...</span>
                                                                            </Tooltip>
                                                                        )}
                                                                        options={
                                                                            [
                                                                                {
                                                                                    value: "Pending PM Approval",
                                                                                    label: "Pending PM Approval",
                                                                                },
                                                                                {
                                                                                    value: "Pending Individual Reviewer Approval",
                                                                                    label: "Pending Individual Reviewer Approval",
                                                                                },
                                                                                {
                                                                                    value: "Pending MTGroup Approval",
                                                                                    label: "Pending MTGroup Approval",
                                                                                },
                                                                                {
                                                                                    value: "Approved",
                                                                                    label: "Approved",
                                                                                },
                                                                                {
                                                                                    value: "Pending Closure",
                                                                                    label: "Pending Closure",
                                                                                },
                                                                                {
                                                                                    value: "Completed",
                                                                                    label: "Completed",
                                                                                },
                                                                                {
                                                                                    value: "Cancelled",
                                                                                    label: "Cancelled",
                                                                                },
                                                                                {
                                                                                    value: "Rejected",
                                                                                    label: "Rejected",
                                                                                },
                                                                            ]
                                                                        }
                                                                    />
                                                            </div>

                                                            <div className="col-12 col-md-12">
                                                                <Button
                                                                    style={{
                                                                        width: '100%',
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleLevelSubmit();
                                                                    }}
                                                                >
                                                                    Submit
                                                                </Button>
                                                            </div>

                                                        </Space>
                                                    </div>

                                                    <div className="col-9 col-md-9">
                                                        <div className="card">
                                                            <Table 
                                                                pagination={false}
                                                                columns={levelColumns} 
                                                                loading={loadingByLevel}
                                                                dataSource={dataByLevel ? dataByLevel?.GetDashboard4ByDateRangeSitePermitStatusAndLevel.results : []}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                          </TabPane>

                                          <TabPane tab="by Child Permit" key="4">
                                          <div className="row dec-row">
                                                <div className="col-12 col-md-12">
                                                    <div className="col-3 col-md-3">
                                                        <Space
                                                            className="col-12 col-md-12"
                                                            direction="vertical"
                                                            size="middle"
                                                        >

                                                            <div className="col-12 col-md-12">
                                                                <RangePicker 
                                                                    style={{ width: "100%" }}
                                                                    onChange={handleChildPermitDateFrom}
                                                                />
                                                            </div>

                                                            <div className="col-12 col-md-12">
                                                                <Select
                                                                        mode="multiple"
                                                                        allowClear
                                                                        placeholder="Please select site(s)"
                                                                        style={{
                                                                            width: '100%',
                                                                        }}
                                                                        onChange={handleChildPermitSiteChange}
                                                                        maxTagCount="responsive"
                                                                        maxTagPlaceholder={(omittedValues) => (
                                                                            <Tooltip
                                                                            styles={{
                                                                                root: {
                                                                                pointerEvents: 'none',
                                                                                },
                                                                            }}
                                                                            title={omittedValues.map(({ label }) => label).join(', ')}
                                                                            >
                                                                            <span>...</span>
                                                                            </Tooltip>
                                                                        )}
                                                                        options={
                                                                            [
                                                                                {
                                                                                    value: "604a288405a8ed2d4d4bba4b",
                                                                                    label: "Fab 10A1",
                                                                                },
                                                                                {
                                                                                    value: "604a286b05a8ed2d4d4bba4a",
                                                                                    label: "Fab 10A2",
                                                                                },
                                                                                {
                                                                                    value: "604a28bb05a8ed2d4d4bba4c",
                                                                                    label: "Fab 10N",
                                                                                },
                                                                                {
                                                                                    value: "60cafd5a4e8783df2ab8afff",
                                                                                    label: "Fab 10NX",
                                                                                },
                                                                                {
                                                                                    value: "6052a5b7be761a25aaec1bd1",
                                                                                    label: "Fab 10W",
                                                                                },
                                                                                {
                                                                                    value: "604a28ee05a8ed2d4d4bba4e",
                                                                                    label: "Fab 10X",
                                                                                }
                                                                            ]
                                                                        }
                                                                    />
                                                            </div>

                                                            <div className="col-12 col-md-12">
                                                                    <Select
                                                                        defaultValue={childPermitTypeByChildPermit}
                                                                        placeholder="Please select permit type"
                                                                            style={{
                                                                                width: '100%',
                                                                            }}
                                                                            onChange={handleChildPermitTypeChange}
                                                                            options={[
                                                                                {
                                                                                    value: 'A',
                                                                                    label: 'A Permit (A1 - A12)',
                                                                                },
                                                                                {
                                                                                    value: 'B',
                                                                                    label: 'B Permit (B1 - B8)',
                                                                                },
                                                                                {
                                                                                    value: 'C',
                                                                                    label: 'C Permit (C1)',
                                                                                },
                                                                            ]}
                                                                    />
                                                            </div>

                                                            <div className="col-12 col-md-12">
                                                                <Button
                                                                    style={{
                                                                        width: '100%',
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        handleChildPermitSubmit();
                                                                    }}
                                                                >
                                                                    Submit
                                                                </Button>
                                                            </div>

                                                        </Space>
                                                    </div>

                                                    <div className="col-9 col-md-9">
                                                        <div className="card">
                                                            <Table 
                                                                pagination={false}
                                                                columns={childPermitColumns} 
                                                                loading={loadingByChildPermit}
                                                                dataSource={dataByChildPermit ? dataByChildPermit?.GetDashboard4ByDateRangeSitePermitStatusAndChildPermitType?.results : []}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                          </TabPane>
                                      </Tabs>
                                  </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </Fragment>
    )
}